import React from "react";
import "./Combo.css";
import image from "../../../assets/images/dummy_pic.jpeg";

const Combo = () => {
  return (
    <div className="bg-gray-100 p-6">
      <div className="max-w-6xl mx-auto bg-white p-6 rounded-lg shadow-lg grid md:grid-cols-2 gap-6">
        {/* Left: Product Images */}
        <div>
          <img
            src={image}
            alt="Product"
            className="w-full rounded-lg shadow-md product-image"
          />
          <div className="flex gap-2 mt-3">
            <img
              src={image}
              className="w-16 h-16 rounded-md border-2 border-blue-500 cursor-pointer thumbnail"
            />
            <img
              src={image}
              className="w-16 h-16 rounded-md border-2 border-gray-300 cursor-pointer thumbnail"
            />
            <img
              src={image}
              className="w-16 h-16 rounded-md border-2 border-gray-300 cursor-pointer thumbnail"
            />
            <img
              src={image}
              className="w-16 h-16 rounded-md border-2 border-gray-300 cursor-pointer thumbnail"
            />
          </div>
        </div>

        {/* Right: Product Details */}
        <div>
          <h2 className="text-2xl font-bold product-title">
            Premium Wireless Headphones
          </h2>
          <p className="text-xl font-semibold text-gray-700 mt-2 price">
            ₹41629.88 <span className="text-sm text-gray-500">($419.96 USD)</span>
          </p>
          <p className="text-gray-600 mt-3 description">
            Experience crystal-clear sound with our premium wireless headphones.
            Features active noise cancellation, 30-hour battery life, and premium
            comfort.
          </p>

          <button className="mt-5 w-full bg-red-500 text-white py-2 rounded-lg shadow-md hover:bg-red-600 buy-button">
            Buy Now
          </button>

          {/* Recommended Add-ons */}
          <div className="mt-6">
            <h3 className="text-lg font-semibold">Recommended Add-ons</h3>
            <div className="mt-2 space-y-2">
              <div className="flex justify-between items-center border p-3 rounded-lg cursor-pointer hover:shadow-md add-on">
                <div>
                  <p className="font-medium">Premium Carrying Case</p>
                  <p className="text-gray-500">₹4149.17</p>
                </div>
                <span className="text-green-500 font-bold">✔</span>
              </div>
              <div className="flex justify-between items-center border p-3 rounded-lg cursor-pointer hover:shadow-md add-on">
                <div>
                  <p className="font-medium">Extended Warranty</p>
                  
                  <p className="text-gray-500">₹3319.17</p>
                </div>
                <span className="text-green-500 font-bold">✔</span>
              </div>
              <div className="flex justify-between items-center border p-3 rounded-lg cursor-pointer hover:shadow-md add-on">
                <div>
                  <p className="font-medium">Premium Audio Cable</p>
                  <p className="text-gray-500">₹2489.17</p>
                </div>
                <span className="text-green-500 font-bold">✔</span>
              </div>
            </div>
          </div>

          {/* Price Breakdown */}
          <div className="mt-6 border-t pt-3">
            <p className="flex justify-between text-gray-700">
              <span>Subtotal:</span> <span>₹34856.68</span>
            </p>
            <p className="flex justify-between text-gray-700">
              <span>GST (18%):</span> <span>₹6274.20</span>
            </p>
            <p className="flex justify-between text-gray-700">
              <span>Shipping:</span> <span>₹499.00</span>
            </p>
            <p className="flex justify-between font-bold text-lg mt-2">
              <span>Total Price:</span> <span>₹41629.88</span>
            </p>
            <p className="text-sm text-gray-500">
              *Price inclusive of GST and shipping
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Combo;
